import { productsProvider } from "./providers/products";
import { validateProductsSearchRequest } from "./schemas/productsSearchSchema";

const ricerca = {

    products: async (data, requestConfig) => {
        const payload = { ...validateProductsSearchRequest(data), isFromVendor: true };
        return productsProvider.productsSearch(payload, requestConfig);
    },
    categorie: async() =>{
        return productsProvider.categorie();
    }

}

export default ricerca;